import { Linkedin, Mail } from "lucide-react";
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabaseClient';
import logo from "@/assets/4fox-logo.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Fetch footer logos from database
  const { data: footerLogos } = useQuery({
    queryKey: ['footer-logos'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('footer_logos')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });
      
      if (error) throw error;
      return data;
    },
  });

  return (
    <footer className="bg-primary text-white py-12">
      <div className="container mx-auto px-4">
        <div className="flex justify-center mb-8">
          <div className="text-center">
            <a href="/" className="inline-block">
              <img src={logo} alt="4FOX Security - Cyber Security Consultancy" className="h-10 mb-4 mx-auto hover:opacity-80 transition-opacity" width="140" height="40" loading="lazy" />
            </a>
            <p className="text-white/70 max-w-2xl">
              Practical cyber security consultancy for businesses of all sizes.
            </p>
          </div>
        </div>

        {/* Dynamic certification logos */}
        <div className="flex justify-center items-center gap-6 mb-8 flex-wrap max-w-4xl mx-auto">
          {footerLogos?.map((logo) => (
            <a
              key={logo.id}
              href={logo.link_url || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center w-24"
            >
              <img
                src={logo.image_url}
                alt={logo.alt_text}
                className="w-full h-14 object-contain opacity-80 hover:opacity-100 transition-opacity"
                loading="lazy"
              />
            </a>
          ))}
        </div>

        {/* Email + LinkedIn section */}
        <div className="flex justify-center items-center gap-6 mb-8">
          <a 
            href="mailto:hello@4fox.uk"
            className="flex items-center gap-2 text-white/70 hover:text-accent transition-colors group"
          >
            <Mail className="w-6 h-6 group-hover:scale-110 transition-transform" />
            <span className="font-medium text-lg">hello@4fox.uk</span>
          </a>
          <span className="text-white/30">|</span>
          <a 
            href="https://www.linkedin.com/company/4foxsecurity/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-white/70 hover:text-accent transition-colors group"
            aria-label="Follow us on LinkedIn"
          >
            <Linkedin className="w-6 h-6 group-hover:scale-110 transition-transform" />
            <span className="font-medium">Follow us on LinkedIn</span>
          </a>
        </div>

        <div className="border-t border-white/10 pt-8 text-center text-white/70 text-sm">
          <p className="mb-2">
            Based in Somerset | Serving Bristol, North Somerset, South Gloucestershire & across the UK
          </p>
          <p>&copy; {currentYear} 4FOX Security. All rights reserved.</p>
          <div className="mt-2 space-x-4">
            <a href="/privacy-policy" className="hover:text-accent transition-colors">Privacy Policy</a>
            <span>·</span>
            <a href="/terms" className="hover:text-accent transition-colors">Terms of Use</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
